import React, { useEffect, useState } from 'react';
import { Modal, Table, Pagination } from 'antd';
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';
import { useReportsStore } from '../../store/slices/createReportsSlice';
import { usePersistedStore } from '../../store/persisted-store';

export default function UserBought({ userId }) {
  const { users } = usePersistedStore()
  const general = useGeneralStore();
  const reports = useReportsStore();
  const [page, setPage] = useState(1);
  
  const visible = general.view.userBoughtModal;
  const loading = reports.crmRequestReport.loading;
  const rawData = reports.crmRequestReport.data;
  const data = Array.isArray(rawData) ? rawData : rawData?.Items;
  // If it's an array, we don't know the exact total. We fake it to allow next page if it's full.
  const total = Array.isArray(rawData) ? (page - 1) * 10 + rawData.length + (rawData.length === 10 ? 1 : 0) : rawData?.Total;

  
  const pageSize = 10;

  useEffect(() => {
      if (visible && userId) {
          reports.getCrmRequestReport({
              usrUserID: userId,
              PageSize: pageSize,
              PageNumber: page,
              CategoryPaymentStatus: 3,
          });
      }
  }, [visible, userId, page]);

  useEffect(() => {
      if (!visible) {
          setPage(1);
      }
  }, [visible]);

  const pageChange = (page) => {
      setPage(page);
  }

  const columns = [
    {
      title: "نام بیمه گزار",
      dataIndex: "PolicyOwnerFullName",
      key: "PolicyOwnerFullName",
      render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
    },
    {
      title: "رشته",
      dataIndex: "BranchTitle",
      key: "BranchTitle",
    },
    {
      title: "شرکت بیمه",
      dataIndex: "CompanyName",
      key: "CompanyName"
    },
    {
      title: "وضعیت",
      dataIndex: "StatusTitle",
      key: "StatusTitle"
    },
    {
      title: "حق بیمه نهایی",
      dataIndex: "ActualAmount",
      key: "ActualAmount",
      render: data => data ? strings.currencyFormat(data) + ' ریال' : '-',
    },
    {
      title: "مبلغ پرداختی",
      dataIndex: "PayableAmount",
      key: "PayableAmount",
      render: data => data ? strings.currencyFormat(data) + ' ریال' : '-',
    },
    {
      title: "تخفیف",
      dataIndex: "AgreementDiscountAmount",
      key: "AgreementDiscountAmount",
      render: data => data ? strings.currencyFormat(data) + ' ریال' : '-',
    },
    {
      title: "کد رهگیری",
      dataIndex: "TrackingCode",
      key: "TrackingCode",
      render: text => text && text.toUpperCase().replace('BM-', '')
    },
    {
      title: "تاریخ صدور",
      dataIndex: "CreationTime",
      key: "CreationTime",
      render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD')),
    }
  ];

  return (
    <Modal
      width={1100}
      title="لیست خریدهای کاربر"
      className="custom-table"
      visible={visible}
      footer={false}
      onCancel={() => general.ToggleUserBoughtModal()}>
      {data && data.length > 0 ? (
          <>
              <Table
                style={{ overflowX: 'scroll' }}
                scroll={{ x: true }}
                bordered
                columns={columns}
                loading={loading}
                rowKey="InsuranceRequestId"
                dataSource={data}
                pagination={false}
              />
              <div style={{ marginTop: '15px' }}>
                  <Pagination
                      defaultCurrent={1}
                      current={page}
                      onChange={pageChange}
                      pageSize={pageSize}
                      total={total}
                      showSizeChanger={false} 
                  />
              </div>
          </>
      ) : (
          <Table
              bordered
              columns={columns}
              loading={loading}
              dataSource={[]}
              pagination={false}
          />
      )}
    </Modal>
  )
}
